
import { defineComponent } from 'vue';

import PrzDialog from '@/components/Social/Dialogs/Parts/Dialog/Component.vue';
import PrzNewComment from '@/components/Social/Dialogs/Parts/NewComment/Component.vue';
import { SocialDialog } from '@/models/Social/social-dialog';

import browser from '@/Utilities/browser';

export default defineComponent({
    components:{
        PrzDialog,
        PrzNewComment
    },
    props:{
        postId:{
            type: String,
            default: undefined
        },
        dialogs: {
            type: Array<SocialDialog>,
            default: () => []
        },
        saveUrl:{
            type: String,
            default: undefined
        },
        kStrings:{
            type: Object,
            default: () => {return {
                newCommentText: '',
                newReplyText: '',
                emptyQuestions: ''
            };}
        },
        isDesktop: {
            type: Boolean,
            default: false
        },
        isGuest: {
            type: Boolean,
            default: true
        },
        allowNewComment: {
            type: Boolean,
            default: true
        }
    },
    destroyed() {
        if(!('virtualKeyboard' in navigator) && browser.isIOS() && !browser.isIOSlegacy()){
            document.documentElement?.removeEventListener("touchstart",this.iOSTouchEvent);
            window.visualViewport?.removeEventListener("resize", this.iOSTextAreaPosition);
        }
    },
    mounted(){
        console.log('Tab comments mounted', this.allowNewComment, this.isGuest);
        //Fixed header on chrome on focus textarea
        if('virtualKeyboard' in navigator && navigator.virtualKeyboard){
            let keyboard: any = navigator.virtualKeyboard;
            try{
                keyboard.overlaysContent = true;
                this.newCommentStyle = {bottom: 'env(keyboard-inset-height)'};
            }catch(e){}
        }

        //Fixed header on iOS and Firefox on focus textarea
        //*************************************
        if(!('virtualKeyboard' in navigator) && browser.isIOS() && !browser.isIOSlegacy()){
            document.documentElement?.addEventListener("touchstart",this.iOSTouchEvent);
            window.visualViewport?.addEventListener("resize", this.iOSTextAreaPosition);
        }
        //*************************************
    },
    data(){
        let postId: string|undefined;
        let parent: string|undefined;
        let newCommentStyle: any = {};
        let timerTextAreaPosition: any = null;
        return {
            postId,
            parent,
            newCommentStyle,
            focusOutActive: false,
            timerTextAreaPosition,
            hasReplyBox: false
        }
    },
    methods:{
        focus(){
            this.newCommentStyle = {bottom: 'auto', top: '50%'}
        },
        focusout(){
            this.newCommentStyle = {};
        },
        showReply(value: boolean){
            this.hasReplyBox = value;
            this.$emit('show-reply', value);
        },

        //Only for iOS and Firefox 
        //*************************************
        iOSTouchEvent(evt: TouchEvent){
            let target: EventTarget|null = evt?.target ?? null;
            let htmlTarget: HTMLElement|null = target ? <HTMLElement> target : null;
            let nodeName: string = htmlTarget ? htmlTarget.tagName.toLocaleLowerCase() : '';
            let body: HTMLElement|null = document.body ?? null;

            if (nodeName == "textarea") {
                evt.preventDefault();
                evt.stopImmediatePropagation();
                htmlTarget && htmlTarget.focus({preventScroll: true});
                body && body.blur();
                this.timerTextAreaPosition = setTimeout(() => {
                    this.iOSTextAreaPosition();
                }, 300);
            }else{
                clearTimeout(this.timerTextAreaPosition);
            }
        },
        iOSTextAreaPosition(){
            clearTimeout(this.timerTextAreaPosition);
            let height = window.visualViewport?.height ?? 0;
            let bottom = height ? window.innerHeight - height : null;
            this.newCommentStyle = bottom !== null ? {bottom: `${bottom}px`} : {};
            if(bottom){
                let elem: Element|null = document.activeElement ?? null;
                if(elem && elem.tagName.toLocaleLowerCase() == "textarea" && !this.focusOutActive){
                    this.focusOutActive = true;
                    window.addEventListener('scroll',this.iOSCloseVirtualKeyboard,{ once: true });
                    elem.addEventListener('focusout',this.iOSFocusOut,{ once: true });
                }
            }
        },
        iOSCloseVirtualKeyboard(){
            let button: HTMLElement|null = document.querySelector('.prz-social-new-comment-button');
            if(button){
                button.focus();
                button.blur();
            }
        },
        iOSFocusOut(){
            this.focusOutActive = false;
            this.newCommentStyle = {bottom: '0px'};
            clearTimeout(this.timerTextAreaPosition);
        }
    }
});

